import React, { createContext } from 'react';
import { TPublicationConfig } from '@vNext/models/PublicationConfig/PublicationConfig';

type TPublicationConfigProvider = {
    config: TPublicationConfig;
    children: React.ReactNode;
}

export const ConfigContext = createContext<TPublicationConfig | Record<string, never>>({});

export const PublicationConfigProvider = ({ config, children }: TPublicationConfigProvider) => (
    <ConfigContext.Provider value={ config }>
        {children}
    </ConfigContext.Provider>
);
